var map = {
	"./china.svg": 265,
	"./circle_black.svg": 968,
	"./circle_blue.svg": 969,
	"./cn.svg": 970,
	"./ellipse_black.svg": 971,
	"./forgotpassword.svg": 323,
	"./france.svg": 266,
	"./highlighted_yellow.svg": 972,
	"./icons/_info.svg": 973,
	"./icons/add_prod.svg": 269,
	"./icons/add_prodOLD.svg": 974,
	"./icons/ask.svg": 975,
	"./icons/facebook.svg": 37,
	"./icons/hatchef.svg": 52,
	"./icons/icone/_info.svg": 976,
	"./icons/icone/hatchef.svg": 977,
	"./icons/icone/info.svg": 978,
	"./icons/icone/play.svg": 979,
	"./icons/icone/plus.svg": 980,
	"./icons/icone/specs.svg": 981,
	"./icons/icone/world.svg": 982,
	"./icons/index-icon-bookmark.svg": 983,
	"./icons/index-icon.svg": 412,
	"./icons/info.svg": 53,
	"./icons/markers-SVG/ask.svg": 984,
	"./icons/markers-SVG/info.svg": 985,
	"./icons/markers-SVG/list.svg": 986,
	"./icons/markers-SVG/recipe.svg": 987,
	"./icons/markers-SVG/web.svg": 988,
	"./icons/play.svg": 46,
	"./icons/play_ip.svg": 989,
	"./icons/plus.svg": 49,
	"./icons/promo.svg": 45,
	"./icons/promo2.svg": 990,
	"./icons/promo3.svg": 991,
	"./icons/promo_10.svg": 992,
	"./icons/promo_classic.svg": 993,
	"./icons/remove_prod.svg": 270,
	"./icons/remove_prodOLD.svg": 994,
	"./icons/shop_list.svg": 271,
	"./icons/specs.svg": 44,
	"./icons/whatsapp.svg": 38,
	"./icons/world.svg": 40,
	"./logo.svg": 995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;